module.exports = __webpack_public_path__ + "img/TECNOLOGIA-IGNIS-2.4b3d706f.jpg";